import { render, staticRenderFns } from "./privacyCom.vue?vue&type=template&id=03e9979a&"
import script from "./privacyCom.vue?vue&type=script&lang=js&"
export * from "./privacyCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports